// extracted by mini-css-extract-plugin
module.exports = {"table":"EarnTable_table__npyid","apyBox":"EarnTable_apyBox__jxDAJ"};